import jQuery from 'jquery';

export default {
    busy (active) {
        let busy = jQuery('#busy');
        active ? busy.removeClass('hidden') : busy.addClass('hidden');
    },
    loader (mode) {
        let loader = jQuery('#page-loader');

        if (mode === 'show') {
            if (loader.length) {
                loader.fadeIn(250);
            } else {
                jQuery('body').prepend('<div id="page-loader"></div>');
            }
        } else if (mode === 'hide') {
            if (loader.length) {
                loader.fadeOut(250);
            }
        }
    },
    init () {
        // Collapsable blocks
        jQuery('body').on('click', '[data-toggle="block-option"]', function () {
            let btn = jQuery(this);
            let block = jQuery(this).closest('.block');

            switch (jQuery(this).data('action')) {
                case 'content_toggle':
                    block.toggleClass('block-opt-hidden');
                    if (block.hasClass('block-opt-hidden')) {
                        btn.find('i').removeClass('icon-arrow-up').addClass('icon-arrow-down');
                    } else {
                        btn.find('i').removeClass('icon-arrow-down').addClass('icon-arrow-up');
                    }
                    break;
            }
        });
    },
    nl2br (str) {
        let breakTag = '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    },
    capitalize (str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
};



// WEBPACK FOOTER //
// ./src/assets/js/planner.js